export function isTouchDevice() {
	return window.matchMedia('(pointer: coarse)').matches
}

export function isOverlayMenu() {
	const overlayMenuBreakpoint =
		parseInt(window.getComputedStyle(document.documentElement).getPropertyValue('--overlay-menu-breakpoint')) || false
	return typeof overlayMenuBreakpoint === 'number' ? window.innerWidth < overlayMenuBreakpoint : true
}

export const activeClass = 'active'

export const visibleClass = 'element-visible'

export function toggleVisibility(element) {
	element.classList.toggle(visibleClass)
}

export function deepMerge(target, source) {
	for (const key in source) {
		if (source[key] instanceof Object && key in target) {
			Object.assign(source[key], deepMerge(target[key], source[key]))
		}
	}
	return { ...target, ...source }
}

export function jsonToObject(json) {
	try {
		const parsed = JSON.parse(json)
		if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
			return parsed
		}
	} catch (e) {
		console.error(e)
	}
	return {}
}
